export default __webpack_public_path__ + "static/media/ic_file_add.0566115b.svg";